import { Tooltip } from '@mui/material';
import React from 'react';

const TruncatedText = ({ text, maxLength = 50 }) => {
  const truncatedText = text.length > maxLength ? text.slice(0, maxLength) + '...' : text;

  return (
    <Tooltip title={text} arrow><span>{truncatedText}</span></Tooltip>
  );
};

export default TruncatedText;
